import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import { Store } from 'lucide-react';


export default function StoreSelectorModal() {
  const { user, setActiveStoreId } = useAuth();
  const [selected, setSelected] = useState<string>('');
  const { t } = useTranslation();

  if (!user || !user.stores || user.stores.length <= 1) return null; // single store or no stores

  const handleConfirm = () => {
    if (selected) {
      setActiveStoreId(selected);
      // Close modal – we can use a state in parent, but for simplicity we reload or use a local state
      window.location.reload(); // quick reload to reflect changes
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-background rounded-lg shadow-lg p-6 max-w-sm w-full">
        <h2 className="text-xl font-bold mb-4 flex items-center gap-2">
          <Store className="w-5 h-5" /> { t('guard.selectStore') || "Select Store" }
        </h2>
        <p className="text-sm text-muted-foreground mb-4">{ t('guard.multipleStores')  || "You are assigned to multiple stores. Please select the one you are currently guarding." }</p>
        <select
          className="w-full p-2 border rounded mb-4 bg-background"
          value={selected}
          onChange={(e) => setSelected(e.target.value)}
        >
          <option value="" disabled>{t('guard.chooseStore') || "Choose a store"}</option>
          {user.stores.map(s => (
            <option key={s.store_id} value={s.store_id}>{s.name}</option>
          ))}
        </select>
        <div className="flex justify-end gap-2">
          <Button onClick={handleConfirm} disabled={!selected}>Confirm</Button>
        </div>
      </div>
    </div>
  );
}
